import React from 'react'
import {Redirect, Route} from "react-router-dom";
import Cookies from 'universal-cookie';
const cookies = new Cookies();

const RequireLogin = ({component: Component, ...rest}) => {
    let access_token = cookies.get("access_token") ;
    if(!access_token) {
        localStorage.setItem("urlBack", window.location.href);
    }

    return (
        <Route {...rest} render={props => {
            if (access_token) {
                return (<Component {...props}/>);
            } else {
                // not login + path name #login
                return (
                    <Redirect to={{
                        pathname: `/login`,
                        state: {from: props.location}
                    }}/>);
            }
        }}/>
    )
};



export default RequireLogin;
